import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { faArrowLeft, faChevronLeft, faChevronRight, faCloudSun, faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ClipLoader, SyncLoader } from 'react-spinners'
import { useNavigate } from 'react-router-dom'
import { useSearchParams } from "react-router-dom";
import { RESET_PERSONALISE_ANALYSIS, RESET_PERSONALISE_MCQ_ANSWER, RESET_PERSONALISE_QUESTIONS, SET_CUSTOM_SKILL_SELECTED, SET_ONBOARDING_SELECTED_SKILL, SET_PERSONALISE_COURSE_NAME } from '../../../redux/actions/types'
import Constants from '../../../common/constants'
import { checkUserAccess, setOnboardingData } from '../../../redux/actions/authentication'
import { getAllSkills } from '../../../redux/actions/skills'
import { getGoalsAndRoles, onboardingSearch } from '../../../redux/actions/userActivity'
import { getAllCourses } from '../../../redux/actions/courses'
import { useDebounce } from '../../../hooks/useDebounce'
import useWindowSize from '../../../hooks/useWindowSize'
import { fetchIsUserFromBetaProduct } from '../../../redux/actions/personaliseCourse'
import ProgressBar from '../../ContentPlayerPage/Quiz/ProgressBar'
import SearchBar from '../../OnboardingRevampPage/SearchBar'
import Skeleton from '../../OnboardingRevampPage/Skeleton'
import SingleList from '../../OnboardingRevampPage/SingleList'
import { Mixpanel } from '../../../config/Mixpanel'


const ExploreCourses = ({ step, setStep , handleSetStep }) => {

    const userName = useSelector(store => store?.profileDetails?.name)
    const customisedSkill = useSelector(state => state.personaliseCourse?.customSkillSelected)
    const email = useSelector(store => store?.profileDetails?.email)
    const betaProductUser = useSelector(store => store?.personaliseCourse?.betaUsers)
    const [ searchValue, setSearchValue ] = useState("")
    const [allCourses, setAllCourses ] = useState([])
    const [ searchedResults, setSearchedResults ] = useState([])
    const [ isLoading, setIsLoading ] = useState([])
    const [ skillList, setSkillList ] = useState([])
    const [ isOnBoarded , setIsOnBoarded ] = useState(false)
    const [ goalClicked, setGoalClicked ] = useState(false)
    const [goalIndex, setGoalIndex ] = useState(0)
    const [ roleClicked, setRoleClicked ] = useState(false)
    const [ roleIndex, setRoleIndex ] = useState(0)
    const [ skillClicked, setSkillClicked ] = useState(false)
    const [ onBoardingSkillLoading, setOnBoardingSkillLoading ] = useState(false)
    const [ skillName, setSkillName ] = useState('')
    const [ roles, setRoles ] = useState([])
    const [ goals, setGoals ] = useState([])
    const [ userInterests, setUserInterests ] = useState({
        courseName: '',
        skillDetails: {},
        goal: '',
        role: '',
        timing: ''
    })
    const [ customSkillSelected, setCustomSkillSelected ] = useState(false)
    const [ selectedFromCoursePage, setSelectedFromCoursePage ] = useState(false)

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const debouncedValue = useDebounce(searchValue, 300)
    const { width } = useWindowSize()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE, {
            distinct_id: email
        })
        setIsLoading(true)
        dispatch(getAllCourses((res) => {
            setAllCourses(res)
            setIsLoading(false)
        }))

        dispatch({ type: RESET_PERSONALISE_QUESTIONS, payload: null })
        dispatch({ type: RESET_PERSONALISE_ANALYSIS, payload: null })
        dispatch({ type: RESET_PERSONALISE_MCQ_ANSWER, payload: null })
        dispatch({ type: SET_CUSTOM_SKILL_SELECTED, payload: false })
        dispatch(fetchIsUserFromBetaProduct())
        dispatch(checkUserAccess((successObj)=>{ setIsOnBoarded(successObj?.is_onboarded)}))
        dispatch(getGoalsAndRoles((successObj) => {
                const filteredGoals = (successObj?.data).filter(
                  (item) => item?.type === "goal"
                );
                const fileredRoles = (successObj?.data).filter(
                  (item) => item?.type === "role"
                );
    
                setRoles(fileredRoles);
                setGoals(filteredGoals);
              },
              (errObj) => {}
            )
          );
    }, [dispatch, email])
    
    useEffect(() => {
        dispatch(onboardingSearch(debouncedValue, (successObj) => {
            setSearchedResults(successObj)
        }))
    }, [debouncedValue, dispatch])

    useEffect(()=>{
        
       
        if(userInterests?.skillDetails?.["skill-name"]){
        dispatch({ type: SET_ONBOARDING_SELECTED_SKILL, payload: userInterests?.skillDetails })
        }
    },[dispatch, userInterests])
    console.log('userInterests', userInterests)
    const handleDomainSelection = (course_slug, course_name) => {
        Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_COURSE_SELECTED, {
            distinct_id: email
        })
        setStep((prev) => prev + 1)
        setIsLoading(true)
        setUserInterests({
            ...userInterests,
            courseName: course_name
        })
        dispatch(getAllSkills(course_slug, (result) => {
            setSkillList(result)
            setIsLoading(false)
        }))
    }

    const handleSkillSelection = (id, index) => {
        console.log('skill selction', id);
      
            Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_SKILL_SELECTED, {
                distinct_id: email
            })
            Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_STEP_SKILL_CARD_CLICKED);
            setSkillName(id?.['skill-name'])
            setCustomSkillSelected(false)
            setSkillClicked(true)
            setUserInterests({
                ...userInterests,
                skillDetails: id
            })
            dispatch({ type: SET_ONBOARDING_SELECTED_SKILL, payload: id })
            handleSetStep(6);

            dispatch({ type: SET_PERSONALISE_COURSE_NAME, payload: { skill_name: id?.["skill-name"], skill_slug: id?.skill_slug }})
            setTimeout(() => setSkillClicked(false), 2500)
        
        if (step === 1){
            setStep((prev) => prev + 1)
        }
    }

    const handleCustomSkillSelection = () => {
        Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_CUSTOM_SKILL_SELECTED, {
            distinct_id: email
        })
        Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_STEP_CUSTOM_CARD_CLICKED);
        setCustomSkillSelected(true)
        dispatch({ type: SET_CUSTOM_SKILL_SELECTED, payload: true })
        dispatch({ type: SET_PERSONALISE_COURSE_NAME, payload: { skill_name: debouncedValue, skill_slug: debouncedValue }})
        setUserInterests({
            ...userInterests,
            skillDetails: { 'id': 0,
                'skill-name': debouncedValue
            }
        })
        dispatch({ type: SET_ONBOARDING_SELECTED_SKILL, payload: { 'id': 0, 'skill-name': debouncedValue }})
        handleSetStep(6);
        setSearchValue("")
        if (step === 1){
            setSelectedFromCoursePage(true)
            setStep(prev => prev + 2)
        }else{
            setSelectedFromCoursePage(false)
            setStep(prev => prev + 1)
        }
    }

    const handleSearchResult = (id) => {
        setSkillClicked(true)
        setSearchValue('')
        setCustomSkillSelected(false)
        Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_SKILL_SELECTED, {
            distinct_id: email
        })
        Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_STEP_SKILL_CARD_CLICKED);
    
        setSkillName(id?.['skill-name'])
        setUserInterests({
            ...userInterests,
            skillDetails: id
        })
        dispatch({ type: SET_ONBOARDING_SELECTED_SKILL, payload: id })
        dispatch({ type: SET_PERSONALISE_COURSE_NAME, payload: { skill_name: id?.["skill-name"], skill_slug: id?.skill_slug }})
        handleSetStep(6);
        if(step === 1){
            setSelectedFromCoursePage(true)
            setTimeout(() => setStep((prev) => prev + 2), 2000)
        }else{
            setSelectedFromCoursePage(false)
            setTimeout(() => setStep(prev => prev + 1), 2000)
        }
        setTimeout(() => setSkillClicked(false), 2500)
    }

    const handleBack = () => {
        if (step === 3 && selectedFromCoursePage){
            setStep(prev => prev - 2)
            setSelectedFromCoursePage(false)
        }else{
            setStep(prev => prev - 1)
        }
    }
    const newLearners = useCallback(() => {
        const time = new Date()
        const hours = time.getHours()
        const minutes = time.getMinutes()
        let maxLearners = hours.toString() + (minutes <= 9 ? "0" + minutes.toString() : minutes.toString())
        console.log(maxLearners)
        return Math.max(parseInt(maxLearners)+9, 171)
    }, [])
    
    return (
    <div className='text-white w-full relative flex flex-col justify-start items-center pb-4' >
            <div className='w-full cursor-pointer text-[20px] leading-none gap-2 font-bold flex justify-start items-center rounded-full' onClick={handleBack}>
                <FontAwesomeIcon icon={faChevronLeft} />
                Explore All Courses
            </div>
            <div className='mt-6 w-full mx-auto flex-1 flex flex-col'>
                    <div className='block'>
                        <div className=''>
                            <SearchBar
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                                setStep={setStep}
                                handleCustomSkillSelection={handleCustomSkillSelection}
                            />
                        </div>
                    </div>
                    {debouncedValue ? (searchedResults?.length > 0 ?
                    <div className=''>
                        {!skillClicked && <h3 className='text-lg font-medium mt-2 mb-2 '>Select A Course</h3>}
                        {!skillClicked ? <div className='grid md:grid-cols-2 md:gap-x-10 rounded-lg bg-[#406AFF]/10'>
                            {searchedResults?.map((item, index) => (
                                <div key={index} className={`flex items-center hover:opacity-70 py-3 px-4 ${index !== searchedResults?.length - 1 ? 'border-b-[1px] border-[#70AEFF]/30' : ''} ${userInterests?.skillDetails?.["skill-name"] === item?.["skill-name"] ? 'border-2 border-[#00C838]' : ''} cursor-pointer`} onClick={() => handleSearchResult(item)}>
                                    <img src={item?.skill_thumbnail?.lesson_videoThumbnail} width={36} height={20} alt="video thumbnail" />
                                    <p className='flex-1 text-sm font-semibold ml-3'>{item?.["skill-name"]}</p>
                                </div>
                            ))}
                        </div> : <div className='border-2 w-full mx-auto md:w-2/3 px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center'>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-sm font-semibold'><span className='text-[#00C1FF] font-bold'>{newLearners()} users</span> learning {skillName} this week</p>
                            <ClipLoader color='#1CB05E' size={20}/>
                        </div>}
                    </div> : 
                    <>
                        <h2 className='text-lg font-medium mt-2 mb-2 '>Select Your Course</h2>
                        <div className='bg-[#406AFF]/10 flex items-center w-full md:w-1/2 py-3 rounded-lg px-4 cursor-pointer' onClick={() => handleCustomSkillSelection()}>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/brainstorming-94359.png?updatedAt=1688727493618" width={24} height={24} alt="brain icon" />
                            <p className='ml-2'>{debouncedValue}</p>
                        </div>
                    </>) : step === 1 ? <div className=''>
                        {isLoading ? <Skeleton /> : 
                        <div>
                            {!skillClicked && <h3 className='text-lg font-medium mt-2 mb-2 flex justify-between items-center'>
                                <div>Select A Category</div>
                                <div className='text-[12px] flex gap-1 justify-end items-center text-white/80'>
                                <div className="w-[68px] h-2 bg-gray-300 rounded-full overflow-hidden">
                                    <div
                                        className="h-full bg-[#2BBD13] rounded-full transition-all duration-300"
                                        style={{ width: `${50}%` }}
                                    ></div>
                                    </div>
                                    Step 1/2
                                </div>
                                
                                </h3>}
                            {!skillClicked ? <div className='grid md:grid-cols-2 md:gap-x-4'>
                                {allCourses?.map((item, index) => (
                                    <SingleList
                                        key={index} 
                                        name={item?.["course-name"]} 
                                        step={step}
                                        slug={item?.course_slug}
                                        imageLink={item?.course_icon?.url}  
                                        handleDomainSelection={handleDomainSelection}
                                        selected={userInterests?.courseName}
                                        index={index}
                                        lastIndex={allCourses?.length - 1}
                                    />
                                ))}
                            </div>  : <div className='border-2 w-full mx-auto md:w-2/3 px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center'>
                                <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                                <p className='text-sm font-semibold'><span className='text-[#00C1FF] font-bold'>{newLearners()} users</span> learning {skillName} this week</p>
                                <ClipLoader color='#1CB05E' size={20}/>
                        </div>}
                        </div>}
                    </div> : 
                    step === 2 ? <div>
                        {isLoading ? <Skeleton /> : 
                        <div>
                            {!skillClicked && <h3 className='text-lg font-medium mt-2 mb-2 flex justify-between items-center'>
                                <div>Select A Category</div>
                                <div className='text-[12px] flex gap-1 justify-end items-center text-white/80'>
                                <div className="w-[68px] h-2 bg-gray-300 rounded-full overflow-hidden">
                                    <div
                                        className="h-full bg-[#2BBD13] rounded-full transition-all duration-300"
                                        style={{ width: `${100}%` }}
                                    ></div>
                                    </div>
                                    Step 2/2
                                </div>
                                </h3>}
                            {!skillClicked ? <div className='grid md:grid-cols-2 md:gap-x-4 '>
                                {skillList?.map((item, index) => (
                                    <SingleList
                                        key={index}
                                        name={item?.["skill-name"]}
                                        step={step}
                                        slug={item}
                                        imageLink={item?.skill_thumbnail}
                                        handleDomainSelection={handleSkillSelection}
                                        selected={userInterests?.skillDetails?.["skill-name"]}
                                        index={index}
                                        lastIndex={skillList?.length - 1}
                                    />
                                ))}
                            </div> : <div className='border-2 w-full mx-auto md:w-2/3 px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center'>
                                <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                                <p className='text-sm font-semibold ml-0.5'><span className='text-[#00C1FF] font-bold'>{newLearners()} users</span> learning {skillName} this week</p>
                                <ClipLoader color='#1CB05E' size={20}/>
                            </div>}
                        </div>}
                    </div> : null}
                </div>
        </div>
        
    )
}

export default ExploreCourses